<template>
	<div>
		<el-dialog title="二维码" :visible.sync="show_qrcode" width="500px" >
			<div class="diabox">
				<el-image :src='get_qrcode()+props' style='width: 200px;height: 200px'>
					<div slot="placeholder" class="image-slot">
						加载中<span class="dot">...</span>
					</div>
				</el-image>
				<div class="tips_qrcode">请使用微信扫描小程序码或下载小程序码</div>
				<div class="tips_qrcode_mini">需绑定及发布正式版才能生成二维码</div>
				<span slot="footer" class="qrcode_btns">
					<el-button @click="show_qrcode = false">取 消</el-button>
					<el-button type="primary" @click="down_qrcode">下 载</el-button>
				</span>
			</div>
		</el-dialog>
		<el-dialog title="小程序链接" :visible.sync="show_src" width="500px" >
			<div style="margin-left: 100px;margin-bottom: 20px;cursor: pointer" @click='show_helper=true'>
				您可以在公众号图文消息使用此链接 <svg-icon icon-class='right'/>
			</div>
			<el-form label-width='100px' style='width: 100%'>
				<el-form-item label='APPID'>
					<el-input disabled :value='info.appid' >
						<span style='cursor: pointer;' @click='copy(info.appid)' slot="append">复制</span>
					</el-input>
				</el-form-item>
				<el-form-item label='小程序路径'>
					<el-input disabled :value='props' >
						<span style='cursor: pointer;'  @click='copy(props)' slot="append">复制</span>
					</el-input>
				</el-form-item>

			</el-form>
			<span slot="footer"  class="dialog-footer">
				<el-button @click="show_src = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加链接到公众号图文消息" :visible.sync="show_helper" width="770px"  >
			<img src="@/assets/add_miniapp.jpg" alt="">
			<span slot="footer"  class="dialog-footer">
				<el-button @click="show_src = false">关 闭</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
	import {get_qrcode,get_app_id} from "@/api/api"
	export default{
		data(){
			return {
				get_qrcode,
				show_helper:false,
				info:{}
			}
		},
		computed:{
			props(){
				return this.$store.state.qrcode.props
			},
			show_qrcode:{
				get(){
					return this.$store.state.qrcode.show_qrcode
				},
				set(){
					this.$store.commit("change_qrcode_show")
				}
			},
			show_src:{
				get(){
					return this.$store.state.qrcode.show_src
				},
				set(){
					this.$store.commit("change_src_show")
				}
			},
		},
		watch:{
			show_src:{
				handler(val){
					this.info = {};
					if(val){
						get_app_id(this,res=>{
							this.info = res.data.info
						})
					}
				},deep:true
			},
		},
		mounted(){

		},
		methods:{
			copy(text){
				this.$copyText(text).then(e=> {
					this.$message("复制成功");
				}, e=> {
					this.$message("复制失败");
				})
			},
			down_qrcode(){
				window.open(this.get_qrcode+this.props+"&download=1");
			}
		}
	}
</script>

<style>
.image-slot{
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.diabox{
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
}
.tips_qrcode{
	margin-top: 20px;
}
.tips_qrcode_mini{
	font-size: 10px;
	color: #aaa;
}
.qrcode_btns{
	margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/qrcode/qrcode.vue